import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';



/* EXISTING COMPONENTS */
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import WeatherWidget from './components/WeatherWidget';
import SmartTools from './components/SmartTools';
import Footer from './components/Footer';
import IndiaMap from './components/IndiaMap';
import AgricultureSummary from './components/AgricultureSummary';
import NotificationPopup from './pages/Notificationpopup';
// import ChatbotToggle from './components/ChatbotToggle';

/* EXISTING PAGES */
import CropAdvisoryPage from './pages/CropAdvisoryPage';
import FertilizerScannerPage from './pages/FertilizerScannerPage';
import CropMonitoringPage from './pages/CropMonitoringPage';
import WaterResources from './pages/WaterResources';
import MandiPriceMarket from './pages/MandiPriceMarket';
import GovSchemes from './pages/GovSchemesPage';
import FertilizerResourcePage from './pages/FertilizerResourcePage';
import FarmerDashboard from './pages/HarvestingCycle';
import GreeneryAnalysisPage from './pages/GreeneryAnalysisPage';
import FarmingVideos from './pages/FarmingVideos';
import GroundwaterDashboard from './pages/GroundwaterDashboard';
import ArtificialHarvesting from './pages/ArtificialHarvesting';

/* NEW PUBLIC PAGE */
import LandingPage from './pages/public/LandingPage';
import StateDashboard from './pages/state/StateDashboard';
import DistrictDashboard from './pages/district/DistrictDashboard';

/* FARMER-ONLY HOME */
import FarmerHome from './pages/farmer/FarmerHome';
/* PROTECTED ROUTE */
const ProtectedRoute = ({ children, allowedRoles }) => {
  const loggedIn = localStorage.getItem('loggedIn') === 'true';
  if (!loggedIn) return <Navigate to="/" replace />;

  if (allowedRoles) {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (!allowedRoles.includes(user.role)) return <Navigate to="/" replace />;
    } catch {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

/* RESPONSIVE LAYOUT STYLES */
const appStyle = {
  display: 'flex',
  fontFamily: 'sans-serif',
  backgroundColor: '#f0fff0',
  minHeight: '100vh',
  alignItems: 'stretch',
};

const weatherWidgetStyle = {
  marginTop: '20px',
};

/* RESPONSIVE LAYOUT HOOK */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
};

/* SHARED LAYOUT WRAPPER */
const AppLayout = ({ children }) => {
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const mainContentStyle = {
    flex: 1,
    padding: isMobile ? '12px' : '20px',
    backgroundColor: '#f0fff0',
    marginLeft: isMobile ? '0' : '280px',
    minWidth: 0,
    width: isMobile ? '100%' : 'calc(100% - 280px)',
    boxSizing: 'border-box',
    overflowX: 'hidden',
  };

  return (
    <div style={appStyle}>
      {/* Mobile overlay */}
      {isMobile && sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 99,
          }}
        />
      )}

      {/* Mobile hamburger button */}
      {isMobile && (
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label="Toggle navigation menu"
          style={{
            position: 'fixed',
            top: '12px',
            left: '12px',
            zIndex: 200,
            background: '#28a745',
            border: 'none',
            borderRadius: '8px',
            padding: '10px',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            minWidth: '44px',
            minHeight: '44px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span style={{ width: '20px', height: '2px', background: 'white', display: 'block', transition: 'all 0.3s', transform: sidebarOpen ? 'rotate(45deg) translateY(7px)' : 'none' }} />
          <span style={{ width: '20px', height: '2px', background: 'white', display: 'block', transition: 'all 0.3s', opacity: sidebarOpen ? 0 : 1 }} />
          <span style={{ width: '20px', height: '2px', background: 'white', display: 'block', transition: 'all 0.3s', transform: sidebarOpen ? 'rotate(-45deg) translateY(-7px)' : 'none' }} />
        </button>
      )}

      <Sidebar isOpen={isMobile ? sidebarOpen : true} isMobile={isMobile} onClose={() => setSidebarOpen(false)} />
      <div style={mainContentStyle}>
        {children}
      </div>
    </div>
  );
};

/* FARMER LAYOUT - FULL ACCESS */
const FarmerLayout = () => {
  return (
    <AppLayout>
      <Routes>
        {/* FARMER DASHBOARD HOME — farmer-only custom dashboard */}
        <Route path="/" element={<FarmerHome />} />
        {/* FARMER SUB PAGES - ALL ACCESS */}
        <Route path="groundwater" element={<GroundwaterDashboard />} />
        <Route path="artificial-harvesting" element={<ArtificialHarvesting />} />
        <Route path="crop-advisory" element={<CropAdvisoryPage />} />
        <Route path="fertilizer" element={<FertilizerScannerPage />} />
        <Route path="crop-monitoring" element={<CropMonitoringPage />} />
        <Route path="water-resources" element={<WaterResources />} />
        <Route path="crops-market" element={<MandiPriceMarket />} />
        <Route path="gov-schemes" element={<GovSchemes />} />
        <Route path="fertilizer-resources" element={<FertilizerResourcePage />} />
        <Route path="harvesting-cycle" element={<FarmerDashboard />} />
        <Route path="greenery-analysis" element={<GreeneryAnalysisPage />} />
        <Route path="farming-videos" element={<FarmingVideos />} />
        {/* ADMIN DASHBOARDS - NOW ACCESSIBLE TO FARMERS */}
        <Route path="state-dashboard" element={<StateDashboard />} />
        <Route path="district-dashboard" element={<DistrictDashboard />} />
      </Routes>
    </AppLayout>
  );
};

/* STATE LAYOUT */
const StateLayout = () => {
  return (
    <AppLayout>
      <Routes>
        {/* STATE DASHBOARD HOME */}
        <Route path="/" element={<StateDashboard />} />
        {/* STATE SUB PAGES */}
        <Route path="groundwater" element={<GroundwaterDashboard />} />
        <Route path="water-resources" element={<WaterResources />} />
        <Route path="crop-advisory" element={<CropAdvisoryPage />} />
        <Route path="crops-market" element={<MandiPriceMarket />} />
        <Route path="fertilizer-resources" element={<FertilizerResourcePage />} />
        <Route path="gov-schemes" element={<GovSchemes />} />
      </Routes>
    </AppLayout>
  );
};

/* GOVT LAYOUT - EXACT REPLICA OF FARMER */
const GovtLayout = () => {
  return (
    <AppLayout>
      <Routes>
        {/* GOVT DASHBOARD HOME */}
        <Route
          path="/"
          element={
            <>
              <Header />
              <div style={weatherWidgetStyle}>
                <WeatherWidget />
              </div>
              <IndiaMap onSelectState={(state) => console.log("Selected:", state)} />
              <AgricultureSummary />
              <NotificationPopup />
              <SmartTools />
              <Footer />
            </>
          }
        />
        {/* GOVT SUB PAGES */}
        <Route path="groundwater" element={<GroundwaterDashboard />} />
        <Route path="crop-advisory" element={<CropAdvisoryPage />} />
        <Route path="crop-monitoring" element={<CropMonitoringPage />} />
        <Route path="water-resources" element={<WaterResources />} />
        <Route path="crops-market" element={<MandiPriceMarket />} />
        <Route path="gov-schemes" element={<GovSchemes />} />
        <Route path="harvesting-cycle" element={<FarmerDashboard />} />
        <Route path="greenery-analysis" element={<GreeneryAnalysisPage />} />
        <Route path="state-dashboard" element={<StateDashboard />} />
        <Route path="district-dashboard" element={<DistrictDashboard />} />
      </Routes>
    </AppLayout>
  );
};

/* DISTRICT LAYOUT */
const DistrictLayout = () => {
  return (
    <AppLayout>
      <Routes>
        {/* DISTRICT DASHBOARD HOME */}
        <Route path="/" element={<DistrictDashboard />} />
        {/* DISTRICT SUB PAGES */}
        <Route path="groundwater" element={<GroundwaterDashboard />} />
        <Route path="water-resources" element={<WaterResources />} />
        <Route path="crop-advisory" element={<CropAdvisoryPage />} />
        <Route path="crops-market" element={<MandiPriceMarket />} />
        <Route path="fertilizer-resources" element={<FertilizerResourcePage />} />
        <Route path="gov-schemes" element={<GovSchemes />} />
      </Routes>
    </AppLayout>
  );
};

function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* PUBLIC LANDING PAGE */}
          <Route path="/" element={<LandingPage />} />
          {/* FARMER DASHBOARD */}
          <Route path="/farmer/*" element={<ProtectedRoute allowedRoles={['farmer']}><FarmerLayout /></ProtectedRoute>} />
          {/* STATE ADMIN DASHBOARD */}
          <Route path="/state/*" element={<ProtectedRoute allowedRoles={['state']}><StateLayout /></ProtectedRoute>} />
          {/* DISTRICT ADMIN DASHBOARD */}
          <Route path="/district/*" element={<ProtectedRoute allowedRoles={['district']}><DistrictLayout /></ProtectedRoute>} />
          {/* GOVT DASHBOARD */}
          <Route path="/govt/*" element={<ProtectedRoute allowedRoles={['govt']}><GovtLayout /></ProtectedRoute>} />
        </Routes>
      </Router>
      {/* Internal Chatbot - Safe and Non-intrusive */}
      {/* <ChatbotToggle /> */}
    </>
  );
}

export default App;